import ProfileState from "../../model/Profile";
import UserInfo from "../../model/userInfo";

export function setProfileUser(setState: React.Dispatch<React.SetStateAction<ProfileState>>, user: UserInfo): void {
    setState({ user: user });
}
